import { Box, Typography } from '@mui/material';
import BannerImage from '@acorn-portal/shared/src/assets/mypolicy/my-policy-lander-banner.png';
import { FC } from 'react';

interface IProps {
	text?: React.ReactNode;
}

const MyPolicyLanderBanner: FC<IProps> = ({ text = <>TEST ACCOUNT</> }) => {
	return (
		<Box
			sx={(theme) => ({
				position: 'relative',
				backgroundImage: `url(${BannerImage})`,
				backgroundRepeat: 'no-repeat',
				backgroundSize: 'cover',
				backgroundPosition: 'center center',
				padding: 2,
				overflow: 'hidden',
				paddingBottom: '30%',
				[theme.breakpoints.down('md')]: {
					height: '250px',
					backgroundSize: 'cover',
				},
			})}
		>
			<Box
				sx={(theme) => ({
					position: 'absolute',
					zIndex: 200,
					top: '50%',
					left: '2rem', // Adjusted the left position
					transform: 'translateY(-50%)',
					overflow: 'hidden',
					width: 'auto',
					maxWidth: '50%',
					[theme.breakpoints.down('md')]: {
						left: '1.5rem',
						fontSize: '4vw',
						maxWidth: '80%',
					},
					[theme.breakpoints.down('sm')]: {
						left: '0',
						fontSize: '5vw',
					},
				})}
			>
				<Typography
					variant='h4'
					sx={(theme) => ({
						color: theme.palette.common.white,
						fontSize: '1.8rem',
						margin: '1.8rem',
						padding: '1rem',
						fontWeight: 300,
						backgroundColor: 'rgba(124, 124, 124, 0.5)',
						[theme.breakpoints.down('md')]: {
							fontSize: '1.5rem',
							margin: '1rem',
							padding: '0.8rem',
						},
						[theme.breakpoints.down('sm')]: {
							fontSize: '1.2rem',
							margin: '0.6rem',
							padding: '0.6rem',
						},
					})}
				>
					{text}
				</Typography>
			</Box>
		</Box>
	);
};

export default MyPolicyLanderBanner;
